
/**
 * Checks whether a password is in a valid format - at least 8 characters, at least 1 capital letter, at least 1 number
 * @param password - password to be tested
 */
export default function passwordIsValid(password: string | null): boolean {
    const pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_+=<>\/\\'":;~`.,|]).{8,}$/;
    return password !== null ? pattern.test(password) : false;
}